import {addQuery} from '@yandex-delivery/utils'

import type {TariffsRepository, TariffsRepositoryProps} from './types'

export function createTariffsRepository(props: TariffsRepositoryProps): TariffsRepository {
  const {fetch} = props

  return {
    fetchTariffsZones({params, ...rest}) {
      return fetch({
        url: addQuery('zones', params),
        method: 'GET',
        ...rest,
      })
    },

    fetchTariffsList({params, ...rest}) {
      return fetch({
        url: addQuery('list', params),
        ...rest,
      })
    },

    fetchCargoInfo({params, ...rest}) {
      return fetch({
        url: addQuery('cargo/info', params),
        ...rest,
      })
    },

    fetchNddInfo({params, ...rest}) {
      return fetch({
        url: addQuery('ndd/info', params),
        ...rest,
      })
    },

    fetchNddExcel({params, ...rest}) {
      return fetch({
        url: addQuery('ndd/excel', params),
        ...rest,
      })
    },

    fetchCargoExcel({params, ...rest}) {
      return fetch({
        url: addQuery('cargo/excel', params),
        ...rest,
      })
    },
  }
}

export * from './types'
